<template>
  <div class="my-3">
    <label>Choose Group Or Location</label>
    <div class="row p-3">
      <div class="col-sm-6 col-md-6 border p-3">
        <label>Select Group/Location</label>
        <b-form-select v-model="GroupOrLocation">
          <template #first
            ><option :value="null" disabled
              >-- Please select an option --</option
            ></template
          >
          <option
            v-for="(op, i) in GroupOrLocationOptions"
            :key="i"
            :value="op.clientId"
            >{{ op.clientName }}</option
          >
        </b-form-select>
        <b-button
          v-on:click="selectUsers"
          :disabled="!GroupOrLocation && status === 'not_accepted'"
          variant="primary"
          class="m-3"
          >Next</b-button
        >
        <b-form-checkbox
          id="checkbox-1"
          v-model="status"
          name="checkbox-1"
          value="accepted"
          unchecked-value="not_accepted"
          class="m-3"
        >
          All
        </b-form-checkbox>
        <p class="m-2">
          (Use all members of this group and skip the search form?)
        </p>
      </div>
      <div class="col-sm-6 col-md-6 border p-3">
        <label>Note :</label>
        <ul>
          <li>
            <p
              >These locations and groups are currently authorized to use this
              program/contest. If you do not see the group you are looking for
              on the list, go to
              <a href="/point-programs/list">Manage Programs & contests</a>,
              click on the program in question and add your desired group to the
              list. Then return to <a href="#">this tool</a> and finish adding
              your points.</p
            >
          </li>
          <li>
            <p>
              If you want to add points to everyone in the entire group or
              groups, simply select the check box titled "All". The wizard will
              bypass the search form and take you directly to the "add points"
              screen.</p
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../../../router/index";
export default {
  name: "AddPointsChooseGroupLocation",
  created() {
    
 if (this.$route.params.programId!=="add") {
    this.$store
      .dispatch("adminAddPoint/fetchClientsByProgrammeId", {
        programId: this.$route.params.programId,
      })
      .then((data) => {
        try {
          data.map(({ clientId, clientName }) => {
            this.GroupOrLocationOptions.push({
              clientId,
              clientName,
            });
          });
        } catch (error) {
          console.log(error);
        }
      });
    } else {
      this.$store
      .dispatch("adminAddPoint/fetchAuthorizedClients")
      .then((data) => {
        try {
          data.map(({ clientId, clientName }) => {
            this.GroupOrLocationOptions.push({
              clientId,
              clientName,
            });
          });
        } catch (error) {
          console.log(error);
        }
      });
    }
  },
  data() {
    return {
      GroupOrLocationOptions: [],
      status: "not_accepted",
      GroupOrLocation: null,
      fetchParameters: {
        searchTerm: "",
        firstName: "",
        lastName: "",
        username: "",
        code: "",
        city: "",
        state: "",
        zip: "",
        phoneNumber: "",
        ssn: "",
        email: "",
        programId: Number(this.$route.params.programId),
        pageNumber: 1,
        pageSize: 5,
        sortField: "",
        sortOrder: "",
      },
    };
  },
  methods: {
    selectUsers: function() {
      this.fetchParameters = {
        ...this.fetchParameters,
        client_id: Number(this.GroupOrLocation),
      };
      console.log(this.fetchParameters);
      this.$store
        .dispatch("adminAddPoint/getUsers", { ...this.fetchParameters })
        .then(async (data) => {
          const allUserData = await this.$store.dispatch(
            "adminAddPoint/getUsers",
            { ...this.fetchParameters, pageSize: data.totalRecords }
          );
          this.allUsers = allUserData.Result;
          if (this.status === "accepted") {
            console.log("ACCEPTED")
            this.$store.dispatch("adminAddPoint/setSelectedUsers", this.allUsers);
          } else {
            console.log("NOT_ACCEPTED")
            this.$store.dispatch("adminAddPoint/setSelectedUsers", this.SelectedUsers);
          }
          
          router.push({
            name:
              this.status === "accepted"
                ? "AdminAddPointsFinalizeListOfUsers"
                : "AdminAddPointsBuildListOfUsers",
            params: {
              programId: this.$route.params.programId,
              clientId: this.GroupOrLocation.toString(),
            },
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
